

  //  $('.popup-imgform').show();
// $('body').css({'overflow':'hidden'});
//  $(window).on('load', function() {
//   $('#coming-soon').click(function() {
//     $('.popup-imgform').hide();
//     $(this).hide(); 
//     $('#MainContent').removeClass('blurred-body'); 
//      $('body').css({'overflow':'visible'});
//   }); 
//  });
window.addEventListener('scroll', function () {
  const header = document.getElementById('header');

  // Get 5% of total page height
  const scrollTrigger = document.body.scrollHeight * 0.01;

  if (window.scrollY > scrollTrigger) {
    header.classList.add('active');
  } else {
    header.classList.remove('active');
  }
});



